import type { ReactNode } from 'react';
import { Icon } from '@iconify/react';

export function MobileMenuRow({
  icon,
  title,
  subtitle,
  onClick,
}: {
  icon: string;
  title: string;
  subtitle: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full p-4 flex items-center gap-3.5 text-left hover:bg-gray-50/80 active:bg-gray-100 transition-colors cursor-pointer"
    >
      <div className="w-10 h-10 rounded-2xl bg-orange-50/80 text-[#FC480D] flex items-center justify-center flex-shrink-0">
        <Icon icon={icon} className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-extrabold text-[#0E1726] text-sm leading-tight">{title}</h3>
        <p className="text-xs text-gray-400 font-medium mt-0.5">{subtitle}</p>
      </div>
      <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-300 flex-shrink-0" />
    </button>
  );
}

export function DesktopMenuCard({
  icon,
  title,
  subtitle,
  children,
}: {
  icon: string;
  title: string;
  subtitle: string;
  children: ReactNode;
}) {
  return (
    <div className="bg-white rounded-3xl border border-[#E0E6ED] p-6 shadow-2xs space-y-4">
      <div className="flex items-center gap-3 pb-3 border-b border-gray-100">
        <div className="w-10 h-10 rounded-2xl bg-orange-50 text-[#FC480D] flex items-center justify-center">
          <Icon icon={icon} className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-extrabold text-[#0E1726] text-base">{title}</h2>
          <p className="text-xs text-gray-400 font-medium">{subtitle}</p>
        </div>
      </div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

export function DesktopMenuRow({
  title,
  subtitle,
  onClick,
  trailingIcon = 'ph:caret-right-bold',
}: {
  title: string;
  subtitle: string;
  onClick: () => void;
  trailingIcon?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full p-3.5 rounded-2xl border border-gray-100 bg-[#F8FAFC] hover:bg-orange-50/50 hover:border-orange-200 transition-all flex items-center justify-between text-left cursor-pointer group"
    >
      <div>
        <h3 className="font-bold text-[#0E1726] text-sm group-hover:text-[#FC480D]">{title}</h3>
        <p className="text-xs text-gray-400 font-medium mt-0.5">{subtitle}</p>
      </div>
      <Icon icon={trailingIcon} className="w-4 h-4 text-gray-400 group-hover:text-[#FC480D] transition-colors" />
    </button>
  );
}
